import { Phone, Mail, MapPin } from "lucide-react";
import { BRANDS } from "@/data/hvm";

export const Footer = () => {
  return (
    <footer data-testid="hvm-footer" className="border-t border-[#26334D] bg-[#080C13]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-3">
              <img src="/accessx-logo-white.png" alt="Access X Oceania logo" width="137" height="32" className="h-8 w-auto" />
              <span className="font-tech text-[10px] tracking-[0.25em] uppercase text-[#F4A031] border border-[#F4A031]/40 px-2 py-0.5 clip-notch-sm">
                HVM
              </span>
            </div>
            <p className="font-display font-bold uppercase text-sm tracking-wide text-white mt-4">
              Protecting people. <span className="text-[#F4A031]">Protecting places.</span>
            </p>
            <p className="text-sm text-[#64748B] leading-relaxed mt-2 max-w-xs">
              Oceania's leading distributor of advanced security and access control systems.
              Hostile vehicle mitigation, specified properly.
            </p>
          </div>
          <div className="space-y-3.5 text-sm">
            <p className="font-tech text-[10px] tracking-[0.3em] uppercase text-[#64748B] mb-4">Contact</p>
            <a href="tel:0800322269" data-testid="footer-phone" className="flex items-center gap-3 text-[#94A3B8] hover:text-[#F4A031] transition-colors">
              <Phone size={14} className="text-[#F4A031]" /> 0800 322 269
              <span className="font-tech text-[9px] tracking-widest text-[#64748B] border border-[#26334D] px-1.5 py-0.5">NZ</span>
            </a>
            <a href="tel:1800284339" data-testid="footer-phone-au" className="flex items-center gap-3 text-[#94A3B8] hover:text-[#F4A031] transition-colors">
              <Phone size={14} className="text-[#F4A031]" /> 1800 284 339
              <span className="font-tech text-[9px] tracking-widest text-[#64748B] border border-[#26334D] px-1.5 py-0.5">AU</span>
            </a>
            <a href="mailto:info@accessxoceania.com" data-testid="footer-email" className="flex items-center gap-3 text-[#94A3B8] hover:text-[#F4A031] transition-colors">
              <Mail size={14} className="text-[#F4A031]" /> info@accessxoceania.com
            </a>
            <p className="flex items-start gap-3 text-[#94A3B8]">
              <MapPin size={14} className="text-[#F4A031] shrink-0 mt-0.5" />
              <span>1/13 Beatrice Tinsley Crescent, Rosedale,<br />Auckland 0632, New Zealand</span>
            </p>
            <p className="flex items-start gap-3 text-[#94A3B8]">
              <MapPin size={14} className="text-[#F4A031] shrink-0 mt-0.5" />
              <span>L9 / 140 Bourke Street, Melbourne,<br />VIC 3000, Australia</span>
            </p>
          </div>
          <div>
            <p className="font-tech text-[10px] tracking-[0.3em] uppercase text-[#64748B] mb-4">Brands</p>
            <div className="flex flex-wrap gap-2.5">
              {BRANDS.map((b) => (
                <span
                  key={b.name}
                  data-testid={`footer-brand-${b.name.split(" ")[0].toLowerCase()}`}
                  title={b.name}
                  className="inline-flex items-center bg-[#0B0F17] border border-[#26334D] rounded-md px-3 h-9"
                >
                  <img src={b.logo} alt={`${b.name} logo`} width="90" height="20" loading="lazy" className="max-h-5 max-w-[90px] object-contain" />
                </span>
              ))}
            </div>
            <a
              href="/blog"
              data-testid="footer-guides-link"
              className="inline-block mt-6 font-tech text-xs tracking-widest uppercase text-[#F4A031] hover:underline"
            >
              HVM blog — standards guides &amp; resources →
            </a>
            <br />
            <a
              href="https://accessx.co.nz/collections/automatic-and-fixed-bollards"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-shop-link"
              className="inline-block mt-3 font-tech text-xs tracking-widest uppercase text-[#F4A031] hover:underline"
            >
              Browse the full catalogue at accessx.co.nz →
            </a>
          </div>
        </div>
        <div className="border-t border-[#26334D] mt-12 pt-8 flex flex-col sm:flex-row justify-between gap-4">
          <p className="font-tech text-[10px] tracking-widest uppercase text-[#64748B]">
            © {new Date().getFullYear()} Access X Oceania — Hostile Vehicle Mitigation across Oceania
          </p>
          <p className="font-tech text-[10px] tracking-widest uppercase text-[#64748B]">
            ISO 22343 • PAS 68 • IWA 14-1 • ASTM F2656
          </p>
        </div>
      </div>
    </footer>
  );
};
